import type { ProductFormProductIngredient } from "src/pages/Product/ProductForm/ProductForm.types";

export const resolveIngredientOriginDefault = (productIngredient: ProductFormProductIngredient): string | null => {
    return productIngredient.ingredientReference?.defaultOrigin ?? productIngredient.ingredient?.origin ?? null;
};

export const resolveIngredientOriginValue = (productIngredient: ProductFormProductIngredient): string | null => {
    return productIngredient.origin ?? resolveIngredientOriginDefault(productIngredient);
};
